import { useEffect } from "react";
import { ShopifyIntegration } from "@/components/shopify-integration";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Store, Zap, Plug } from "lucide-react";

export default function IntegrationsPage() {
  useEffect(() => {
    document.title = "Integrations | OpenBox by ShopJimmy";
  }, []);

  return (
    <>

      <div className="container py-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold flex items-center gap-3">
              <Plug className="h-8 w-8" />
              Integrations
            </h1>
            <p className="text-muted-foreground mt-2">
              Connect your e-commerce platforms to automatically sync inventory
            </p>
          </div>

          <Tabs defaultValue="shopify" className="space-y-4">
            <TabsList>
              <TabsTrigger value="shopify" className="flex items-center gap-2" data-testid="tab-shopify">
                <Store className="h-4 w-4" />
                Shopify
              </TabsTrigger>
              <TabsTrigger value="more" disabled className="flex items-center gap-2" data-testid="tab-more">
                <Zap className="h-4 w-4" />
                More Coming Soon
              </TabsTrigger>
            </TabsList>

            <TabsContent value="shopify">
              <ShopifyIntegration />
            </TabsContent>

            <TabsContent value="more">
              <Card>
                <CardHeader>
                  <CardTitle>More Integrations Coming Soon</CardTitle>
                  <CardDescription>
                    We're working on adding more e-commerce platform integrations
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Have a platform you'd like us to support? Let us know!
                  </p>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </>
  );
}
